import { Block, Image, madissaia, palette, spacing, Typography, useBreakpoints } from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import IntercomButton from "../HomeHeader/IntercomButton";

const Contact = () => {
  const { t } = useTranslation();
  const { md } = useBreakpoints();

  return (
    <Block marginTop={md ? 2 : 4} style={styles.container}>
      <Typography variant="bodyBold">{t("screens.category.haveQuestions")}</Typography>
      <Typography variant="paragraph" style={styles.text}>
        {t("screens.category.contactCustomerSupport")}
      </Typography>

      <IntercomButton style={styles.intercomContainer} variant="primary" />
      <Block style={styles.img}>
        <Image source={madissaia} contentFit="contain" height={214} width={170} />
      </Block>
    </Block>
  );
};

export default React.memo(Contact);

const styles = StyleSheet.create({
  container: {
    padding: spacing.unit * 3,
    borderRadius: spacing.radius,
    backgroundColor: palette.secondary.lightPink,
  },
  text: {
    marginTop: spacing.unit,
    maxWidth: spacing.unit * 22,
    minHeight: spacing.unit * 8.5,
  },
  intercomContainer: {
    marginLeft: 0,
    width: spacing.unit * 11.5,
    marginTop: spacing.unit * 3.5,
  },
  img: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
});
